export default {
    locations: {
        city: {
            tehran: 'تهران',
            mashhad: 'مشهد',
            shiraz: 'شیراز',
            kish: 'کیش',
            tabriz: 'تبریز',
            gheshm: 'قشم',
            isfahan: 'اصفهان',
            asaluyeh: 'عسلویه',
            ahvaz: 'اهواز',
            khorramabad: 'خرم آباد',
        },
    },
    main: {
        title: 'سامانه اسلات',
    },
    ra: {
        action: {
            add_filter: 'اضافه‌کردن فیلتر',
            add: 'اضافه',
            back: 'بازگشت',
            bulk_actions: '۱ آیتم انتخاب شد |||| %{smart_count} عدد از آیتم‌ها انتخاب شدند',
            cancel: 'انصراف',
            clear_input_value: 'پاک‌کردن مقدار',
            clear: 'پاک کردن',
            clone: 'شبیه‌سازی',
            confirm: 'تایید',
            reject: 'عدم تایید',
            create: 'ایجاد',
            delete: 'حذف',
            edit: 'ویرایش',
            export: 'دریافت خروجی',
            list: 'لیست',
            refresh: 'بروز‌رسانی',
            remove_filter: 'حذف این فیلتر',
            remove: 'حذف',
            save: 'ذخیره',
            search: 'جست‌ و جو',
            show: 'نمایش',
            sort: 'مرتب‌سازی',
            undo: 'لغو',
            unselect: 'عدم انتخاب',
            expand: 'باز کن',
            close: 'بستن',
            close_menu: 'بستن منو',
            open_menu: 'باز کردن منو',
            addRequest: 'افزودن',
            submit: 'ثبت',
            review: 'بررسی',
            gotIt: 'متوجه شدم',
            offer: 'پیشنهاد',
            setOffer: 'ثبت پیشنهاد',
            cancelRequest: 'لغو درخواست',
            comingFlight: 'پرواز برگشت',
            cancellation: 'ابطال',
            reEstablish: 'برقراری مجدد',
            timeChange: 'تغییر زمان',
            getFlightInfo: 'دریافت اطلاعات',
            preview: 'پیش‌ نمایش',
        },
        boolean: {
            true: 'بله',
            false: 'خیر',
            null: '',
        },
        page: {
            create: 'ایجاد %{name}',
            dashboard: 'داشبورد',
            edit: '%{name} #%{id}',
            error: 'مشکلی ایجاد شد',
            list: 'لیست %{name}',
            loading: 'در حال بارگزاری',
            not_found: 'پیدا نشد',
            show: '%{name} #%{id}',
            empty: 'هنوز سطری از %{name} وجود ندارد.',
            invite: 'آیا میخواهید یک مورد اضافه کنید؟',
        },
        input: {
            file: {
                upload_several: 'تعدادی فایل برای آپلود دراپ کنید، یا برای انتخاب آن‌ها کلیک کنید.',
                upload_single: 'فایلی را برای آپلود دراپ کنید، یا برای انتخاب آن کلیک کنید',
            },
            image: {
                upload_several: 'تعدادی عکس برای آپلود دراپ کنید، یا برای انتخاب آن‌ها کلیک کنید.',
                upload_single: 'عکسی را برای آپلود دراپ کنید، یا برای انتخاب آن کلیک کنید',
            },
            references: {
                all_missing: 'امکان پیدا کردن اطلاعات ارجاعی وجود ندارد.',
                many_missing: 'حداقل یکی از مراجع در دسترس نیست.',
                single_missing: 'مرجع مورد نظر در دسترس نیست.',
            },
            password: {
                toggle_visible: 'پنهان کردن رمز عبور',
                toggle_hidden: 'نمایش رمز عبور',
            },
        },
        message: {
            about: 'درباره',
            are_you_sure: 'آیا اطمینان دارید ؟',
            bulk_delete_content:
                'آیا از حذف  %{name} اطمینان دارید؟ |||| آیا از حدف %{smart_count} عدد از آیتم‌ها اطمینان دارید؟',
            bulk_delete_title: 'حذف %{name} |||| حذف %{smart_count} عدد از آیتم‌های %{name}',
            delete_content: 'آیا از حذف این آیتم اطمینان دارید؟',
            reset_user_mfa: 'آیا از ریست کردن ورود دو مرحله‌ای کاربر اطمینان دارید؟',
            delete_title: 'حذف %{name} #%{id}',
            details: 'جزییات',
            error: 'خطایی در مرورگر رخ داد. درخواست شما کامل نشد',
            invalid_form: 'فرم درست پر نشده است. لطفا خطاها را بررسی کنید',
            loading: 'صفحه در حال بارگزاری است، چند لحظه صبر کنید',
            no: 'خیر',
            not_found: 'شما یک نشانی اینترنتی اشتباه تایپ کردید یا پیغام بدی را دنبال کردید.',
            yes: 'بله',
            unsaved_changes: 'تغییرات شما ذخیره نشده اند. آیا مطمئن هستید که می خواهید از آنها چشم پوشی کنید؟',
            addVoiceFileToQueue: 'آیا میخواهید اعلان عمومی را به صف اضافه کنید؟',
            disableAirportQueue: 'آیا تمایل به غیرفعال کردن صف دارید؟',
            enableAirportQueue: 'آیا تمایل به فعال کردن صف دارید؟',
            disableTerminalAnnouncement: 'آیا تمایل به متوقف کردن اعلان ها دارید؟',
            enableAirportQueueAnnouncement: 'آیا تمایل به پخش کردن اعلان ها دارید؟',
            chooseFlightPath: 'لطفا مسیر پرواز را انتخاب کنید',
            chooseIncomingOugoing: 'لطفا نوع پرواز را انتخاب کنید',
            chooseTypeOfStay: 'لطفا نوع اقامت را انتخاب کنید',
            chooseSourceCity: 'شهر مبدا را انتخاب کنید',
            chooseDestinationCity: 'شهر مقصد را انتخاب کنید',
            sourceHasToBe: 'در پروازهای خروجی مبدا باید تهران باشد',
            finalDestinationHasToBe: 'در پروازهای ورودی مقصد نهایی باید تهران باشد',
            allDestinationsHasToBe: 'در پروازهای چند مسیره تمام شهرهای مقصد باید انتخاب شوند',
            sameCities: 'مبدا و مقصد نمی توانند یکسان باشند',
            sameTimes: 'زمان ورود و خروج نمی توانند یکسان باشد',
            entranceTimeIsBefore: 'زمان خروج نمی تواند بعد از زمان ورود باشد',
            sameDate: 'تاریخ شروع و پایان نمی توانند یکسان باشد',
            endDateIsBefore: 'تاریخ پایان نمی تواند قبل از تاریخ شروع باشد',
            notRightTime: 'مدت زمان پرواز درست تعیین نشده است',
            chooseMonitoringFile: 'فایل شماره نظارت را آپلود کنید',
            uploadMonitoringFile: 'فایل مورد نظر را آپلود کنید',
            flightNumberLength: 'شماره پرواز باید حداقل ۳ و حداکثر ۴ رقمی باشد',
            twoWayTehran: 'در پروازهای رفت و برگشت مبدا یا مقصد نهایی باید تهران باشد',
            createComingFlight: 'لطفا پرواز برگشت را نیز ایجاد کنید',
            departureTimeOfComingWay: 'زمان خروج پرواز برگشت باید بعد از زمان ورود پرواز رفت باشد',
            timeRestrainExist: 'این محدودیت قبلا ثبت شده‌است',
            cityRestrainExist: 'این محدودیت شهری قبلا ثبت شده‌است',
            nightStayRestrainExist: 'این ظرفیت شب خوابی قبلا ثبت شده‌است',
            enterFlightNumber: 'شماره پرواز را وارد کنید',
            selectRplDate: 'تاریخ برنامه فصلی را انتخاب کنید',
            reportGenerationNotAllowed: 'نوع درخواست، هواپیمایی و تاریخ ثبت درخواست باید یکسان باشد',
            notAllowedRequestStatus: 'درخواست باید در وضعیت تایید ادمین باشد',
            notSameWeekDays: 'روزهای پرواز برگشت با روزهای پرواز رفت یکسان نیست',
            comingFlightDates: 'تاریخ شروع و پایان پرواز برگشت باید یک روز بعد از پرواز رفت باشد',
            twoWayDaysNotSame: 'تعداد روزهای پروازهای رفت و برگشت باید یکسان باشد',
            comingDaysNotShift: 'روزهای پرواز برگشت باید یک روز بعد از پرواز رفت باشند',
            wrongTimesForDays: 'با توجه به روزهای پروازی ساعت اشتباه انتخاب شده‌است.',
            wrongDatesForDays: 'با توجه به روزهای پروازی تاریخ اشتباه انتخاب شده‌است.',
            notAllowedRequestRemoval: 'فقط درخواست‌هایی با وضعیت ایجاد قابل حذف هستند',
            notActiveRplSeason: 'در حال حاضر امکان ثبت این برنامه فصلی وجود ندارد',
            wrongDates: 'تاریخ شروع و پایان اشتباه است',
            comingFlightBeforeDates: 'تاریخ شروع و پایان پرواز برگشت نمی‌تواند قبل از پرواز رفت باشد',
            submitWithPlus: 'ثبت به صورت %{flightNumber}',
        },
        navigation: {
            no_results: 'نتیجه‌ای پیدا نشد',
            no_more_results: 'شماره صفحه‌ی %{page} خارج از محدوده مجاز است. صفحه قبل را امتحان کنید.',
            page_out_of_boundaries: 'شماره صفحه %{page} خارج از محدوده است',
            page_out_from_end: 'نمی‌توان به بعد از صفحه آخر رفت',
            page_out_from_begin: 'نمی‌توان به قبل از صفحه اول رفت',
            page_range_info: '%{offsetBegin}-%{offsetEnd} (کل: %{total})',
            page_rows_per_page: 'تعداد ردیف‌ها در صفحه:',
            next: 'بعدی',
            prev: 'قبلی',
        },
        auth: {
            auth_check_error: 'لطفا برای ادامه وارد شوید',
            user_menu: 'پروفایل',
            username: 'نام‌کاربری',
            password: 'رمز عبور',
            sign_in: 'ورود',
            sign_in_error: 'شناسایی با شکست مواجه شد، دوباره تلاش کنید',
            logout: 'خروج',
        },
        notification: {
            updated: 'المان بروز‌رسانی شد',
            created: 'المان ایجاد شد',
            deleted: 'المان حذف شد',
            bad_item: 'المان اشتباه',
            item_doesnt_exist: 'المان پیدا نشد',
            http_error: 'خطا در برقراری ارتباط با سرور',
            data_provider_error: 'خطا در دریافت اطلاعات',
            canceled: 'لغو شد',
            logged_out: 'نشست کاربری شما به پایان رسیده است، لطفا دوباره وصل شوید.',
        },
        validation: {
            required: 'اجباری',
            minLength: 'حداقل باید %{min} کارکتر باشد',
            maxLength: 'باید %{max} کارکتر یا کمتر باشد',
            minValue: 'حداقل باید %{min} باشد',
            maxValue: 'باید %{max} یا کمتر باشد',
            number: 'باید یک عدد باشد',
            email: 'باید یک آدرس ایمیل صحیح باشد',
            oneOf: 'باید انتخابی از این گزینه‌ها باشد: %{options}',
            regex: 'باید با فرمت خاصی هماهنگ باشد (regexp): %{pattern}',
        },
        words: {
            name: 'نام',
            description: 'توضیحات',
            ip: 'آی پی',
            religiousTimesOnTheHorizonOf: 'اوقات شرعی به افق',
            authorizationFailed: 'امکان دسترسی وجود ندارد',
            queueAnnouncements: 'صف اعلان ترمینال ها',
            queueName: 'نام صف',
            queueCount: 'تعداد در صف',
            playing: 'در حال پخش',
            play: 'پخش',
            download: 'دانلود',
            flightType: 'نوع پرواز',
            sourceDestination: 'مبدا-مقصد',
            status: 'وضعیت',
            zone: 'زون',
            hall: 'سالن',
            TODAY: 'امروز',
            today: 'امروز',
            startDate: 'تاریخ شروع',
            startTime: 'ساعت خروج',
            endDate: 'تاریخ پایان',
            endTime: 'ساعت ورود',
            selectStartDate: 'تاریخ شروع را انتخاب کنید',
            selectDepartureTime: 'ساعت خروج را انتخاب کنید',
            selectEndDate: 'تاریخ پایان را انتخاب کنید',
            selectEntranceTime: 'ساعت ورود را انتخاب کنید',
            selectLetterDate: 'تاریخ ایجاد نامه را انتخاب کنید',
            halls: 'سالن ها',
            addHall: 'افزودن سالن',
            scheduleType: 'نوع زمانبندی',
            once: 'یکبار',
            daily: 'روزانه',
            day: 'روز',
            week: 'هفته',
            weekdays: 'روزهای هفته',
            weekDays: 'روزهای هفته',
            weekly: 'هفتگی',
            title: 'عنوان',
            morningAzan: 'اذان صبح',
            noonAzan: 'اذان ظهر',
            nightAzan: 'اذان مغرب',
            time: 'ساعت',
            previousDay: 'روز گذشته',
            reports: 'گزارشات',
            flightInformation: 'مشخصات پروازها',
            flightReports: 'گزارش پروازها',
            services: 'سرویس ها',
            announcementManagement: 'مدیریت اعلان ها',
            playList: 'لیست پخش',
            announcementMapping: 'مدیریت اعلان ها',
            terminals: 'ترمینال ها',
            queues: 'صف ها',
            queue: 'صف',
            zondes: 'زون ها',
            flightStatus: 'حالت های پروازی',
            statusDesc: 'توضیح حالت های پروازی',
            status: 'وضعیت',
            secondStatus: 'وضعیت دوم',
            voiceFiles: 'فایل های صوتی',
            voiceFile: 'فایل صوتی',
            successFlightAnnouncement: 'اعلان های موفق پروازها',
            enableAirportQueueAnnouncement: 'فعال کردن پخش اعلان ها',
            disableAirportQueueAnnouncement: 'غیرفعال کردن پخش اعلان ها',
            disableAirportQueue: 'غیرفعال کردن صف',
            enableAirportQueue: 'فعال کردن صف',
            generalAnnoucement: 'اعلان های عمومی',
            emptyReport: 'گزارشی با این فیلترها یافت نشد',
            noDetails: 'جزییاتی یافت نشد',
            terminal: 'ترمینال',
            queueIP: 'آی پی',
            extension: 'داخلی',
            gate: 'گیت',
            counter: 'کانتر',
            sourceCity: 'مبدا',
            destinationCity: 'مقصد',
            scheduledTime: 'زمان طبق برنامه',
            actualTime: 'زمان واقعی',
            airline: 'هواپیمایی',
            row: 'ردیف',
            via: 'مسیر',
            logo: 'لوگو',
            refreshment: 'پذیرایی',
            announce: 'اعلان',
            canceled: 'باطل شده',
            timeout: 'انقضای زمان اعلان',
            removedManually: 'حذف دستی از صف',
            noFilters: 'هیچ فیلتری انتخاب نشده است',
            resetFilters: 'حذف فیلترها',
            filters: 'فیلترها',
            flightAnnouncement: 'اعلان پرواز',
            announceType: 'نوع اعلان',
            terminalName: 'ترمینال',
            terminalDesc: 'توضیح',
            zoneDesc: 'توضیح',
            zoneId: 'آی دی',
            zones: 'زون ها',
            zone: 'زون',
            schedules: 'زمان بندی ها',
            queueDesc: 'صف',
            enqueueDate: 'ورود به صف',
            enqueuedBy: 'ورود توسط',
            dequeueDate: 'زمان علان',
            dequeueType: 'علت خروج',
            repetitionNum: 'تعداد تکرار',
            contentLink: 'فایل ضبط شده',
            details: 'جزییات',
            GENERAL_ANNOUNCE: 'اعلان عمومی',
            FLIGHT_ANNOUNCE: 'پرواز',
            ANNOUCE_MANUALLY: 'اعلان دستی',
            ANNOUCE_BY_SYSTEM: 'سیستمی',
            ANNOUNCE: 'اعلان',
            TIMEOUT: 'منقضی شد',
            REMOVED: 'حذف شده',
            announcedDate: 'تاریخ اعلان',
            toCity: 'مقصد',
            fromCity: 'مبدا',
            fromCity: 'مبدا',
            viaCity: 'شهرهای میانی',
            flightTypeCd: 'نوع پرواز',
            announcedId: 'آیدی اعلان',
            id: 'آیدی',
            flightDate: 'تاریخ پرواز',
            flightStatusReason: 'علت حالت پروازی',
            flightSecondStatus: 'حالت دوم پروازی',
            flightId: 'آیدی پرواز',
            hallDescription: 'توضیح سالن',
            pinNumber: 'شماره پین',
            hallName: 'نام سالن',
            zoneName: 'نام زون',
            queueDescription: 'توضیح صف',
            terminalDescription: 'توضیح ترمینال',
            statusDescription: 'توضیح حالت پروازی',
            zoneMappingName: 'نام زون',
            statusName: 'نام حالت پروازی',
            statusDesc: 'توضیح حالت پروازی',
            statusPriority: 'اولویت',
            doAnnouncement: 'اعلام شود؟',
            announcementRepetition: 'تعداد دفعات تکرار',
            announcementInterval: 'فاصله زمانی تکرارها(دقیقه)',
            announcementTimeout: 'زمان انقضا(دقیقه)',
            statusColor: 'شماره رنگ',
            voiceServiceIdentity: 'شناسه فایل',
            voiceServiceName: 'نام فایل صوتی',
            fileName: 'نام فایل',
            priority: 'اولویت',
            playSignalBefore: 'پخش سیگنال قبل از اعلان	',
            addShortcutToDashboard: 'نمایش در داشبورد',
            voiceServiceType: 'نوع فایل صوتی',
            scheduledPlaylist: 'لیست پخش',
            startTime: 'ساعت شروع',
            allServices: 'همه سرویس ها',
            dateTimeFrom: 'از تاریخ',
            dateTime: 'تاریخ',
            startDateFrom: 'شروع از تاریخ',
            endDateFrom: 'پایان از تاریخ',
            dateTimeThru: 'تا تاریخ',
            startDateTimeThru: 'شروع تا تاریخ',
            endDateTimeThru: 'پایان تا تاریخ',
            THIS_WEEK: 'هفته جاری',
            thisWeek: 'هفته جاری',
            thisMonth: 'ماه جاری',
            THIS_MONTH: 'ماه جاری',
            thisYear: 'سال جاری',
            newZone: 'زون جدید',
            sun: 'یک‌شنبه',
            mon: 'دوشنبه',
            tue: 'سه‌شنبه',
            wed: 'چهارشنبه',
            thu: 'پنج‌شنبه',
            fri: 'جمعه',
            sat: 'شنبه',
            alternating: 'متناوب',
            minute: 'دقیقه',
            min: 'دقیقه',
            day: 'روز',
            security: 'امنیت',
            groups: 'گروه ها',
            policies: 'سیاست ها',
            users: 'کاربران',
            user: 'کاربر',
            usersInThisGroup: 'کاربران در این گروه',
            groupsOfThisUser: 'گروه های این کاربر',
            username: 'نام کاربری',
            connected: 'متصل به سرور',
            disconnected: 'عدم اتصال به سرور',
            generalAnnounce: 'اعلان عمومی',
            flightAnnounce: 'اعلان پرواز',
            dequeueType: 'نوع خروج از صف',
            menuItem: 'آیتم',
            menuSububItem: 'زیرآیتم',
            allFlightRequests: 'کل درخواست ها',
            flightRequestType: 'نوع درخواست پرواز',
            requestType: 'نوع درخواست',
            newFlightRequest: 'درخواست جدید',
            chooseFlightRequestType: 'درخواست مورد نظر خود را انتخاب کنید',
            monitoringNumber: 'شماره نظارت',
            monitoringNumberFile: 'فایل شماره نظارت',
            chooseMonitoringNumber: 'شماره نظارت مورد نظر را انتخاب کنید',
            flightInformation: 'مشخصات پرواز',
            flightPath: 'مسیر پرواز',
            requestInformation: 'مشخصات درخواست',
            dropZoneText: 'فایل را اینجا کشیده یا کلیک کنید',
            chooseSourceCity: 'مبدا مورد نظر را انتخاب کنید',
            chooseDestinationCity: 'مقصد مورد نظر را انتخاب کنید',
            flightRequestStatus: 'وضعیت',
            airplaneType: 'نوع هواپیما',
            flightNumber: 'شماره پرواز',
            entranceTime: 'زمان ورود',
            entranceTimeTo: 'زمان ورود به',
            departureTime: 'زمان خروج',
            departureTimeFrom: 'زمان خروج از',
            flightTime: 'زمان پرواز',
            register: 'رجیستر',
            staying: 'اقامت',
            nightStay: 'شب خواب',
            other: 'غیره',
            enterAirplaneType: 'نوع هواپیما را وارد کنید',
            enterFlightNumber: 'شماره پرواز را وارد کنید',
            chooseStartDate: 'زمان شروع را انتخاب کنید',
            chooseEndDate: 'زمان پایان را انتخاب کنید',
            chooseEntranceTime: 'زمان ورود را انتخاب کنید',
            chooseDepartureTime: 'زمان خروج را انتخاب کنید',
            enterRegister: 'رجیستر را وارد کنید',
            multiplePath: 'چند مسیره',
            singlePath: 'تک مسیره',
            incoming: 'ورودی',
            outgoing: 'خروجی',
            twoWay: 'ورودی-خروجی',
            flight: 'پرواز',
            requestNumber: 'شماره درخواست',
            incomingFlights: 'پروازهای ورودی',
            outgoingFlights: 'پروازهای خروجی',
            timeSlot: 'بازه ساعتی',
            enter: 'وارد کنید',
            select: 'انتخاب کنید',
            daysOfWeek: 'ایام هفته',
            sourceCityName: 'نام مبدا',
            destinationCityName: 'نام مقصد',
            startDateName: 'تاریخ شروع',
            endDateName: 'تاریخ پایان',
            createdAt: 'تاریخ ایجاد',
            submittedAt: 'تاریخ ثبت',
            errors: 'خطاها',
            error: 'خطا',
            flightRequestDetails: 'بررسی درخواست',
            requestStatus: 'وضعیت درخواست',
            finalChecking: 'بررسی نهایی',
            reasonsOfRejection: 'دلایل عدم تایید',
            saveFlightRequest: 'ذخیره تغییرات',
            airlineLogo: 'ایرلاین',
            history: 'تاریخچه',
            requestDetails: 'جزيیات درخواست',
            systemConfigs: 'قوانین سیستمی',
            configs: 'تنظیمات',
            airportCapacity: 'ظرفیت فرودگاه',
            airlineTimeRangeShare: 'سهم هر شرکت هواپیمایی در هر ساعت (محدودیت زمانی)',
            airlineCityRangeShare: 'سهم هر شرکت هواپیمایی برای هر شهر (محدودیت شهری)',
            timeRange: 'بازه زمانی (دقیقه)',
            timeRangeCapacity: 'ظرفیت در بازه زمانی',
            samePathCapacity: 'ظرفیت پروازهای هم مسیری',
            sameRouteCapacity: 'ظرفیت پروازهای هم روتی',
            minMinuteDifference: 'حداقل فاصله زمانی (دقیقه)',
            adhan: 'اذان',
            exitFlightAdhanTime: 'حداقل فاصله زمانی پرواز خروجی بعد از اذان',
            blockTime: 'بلاک تایم',
            rplOnlyTimeRange: 'بازه زمانی محدود',
            isRuleEffective: 'اعمال محدودیت؟',
            limitedFlights: 'پروازهای محدود شده',
            startHour: 'ساعت شروع',
            endHour: 'ساعت پایان',
            enterTimeRange: 'بازه زمانی را وارد کنید',
            enterMinuteCapacity: 'ظرفیت را وارد کنید',
            enterexitFlightAdhanTime: 'فاصله زمانی را وارد کنید',
            enterBlockTime: 'بلاک تایم را وارد',
            rows: 'ردیف‌ها',
            hourRange: 'بازه ساعتی',
            days: 'روزها',
            count: 'تعداد',
            actions: 'عملیات',
            city: 'شهر',
            rplDate: 'تاریخ برنامه فصلی',
            summer: 'تابستان',
            winter: 'زمستان',
            currentRplSeason: 'برنامه فصلی کنونی',
            enterMonitoringNumber: 'شماره نظارت را وارد کنید',
            timeShare: 'محدودیت زمانی',
            cityShare: 'محدودیت شهری',
            airportHourlyCapacity: 'ظرفیت فرودگاه در بازه یک ساعته',
            airlineHourlyShare: 'سهم پیش‌ فرض هواپیمایی در بازه یک ساعته',
            airlinesNightStayShare: 'ظرفیت شب خوابی هواپیمایی',
            airlineCityShare: 'سهم هواپیمایی برای شهر مقصد',
            hourCapacity: 'ظرفیت فرودگاه در بازه یک ساعته',
            minuteCapacity: 'ظرفیت فرودگاه در بازه زمانی',
            timeRangeShare: 'سهم در بازه یک ساعته',
            timeDependency: 'وابستگی زمانی',
            cityDependency: 'وابستگی شهری',
            deleteRestrain: 'حذف محدودیت',
            addRestrain: 'ثبت محدودیت',
            updatingAirline: 'بروزرسانی هواپیمایی',
            nightStayDependency: 'ظرفیت شب خوابی',
            exportFlightsToExcel: 'csv خروجی',
            flightsReport: 'گزارش پروازها',
            calendar: 'تقویم',
            airlineName: 'نام هواپیمایی',
            creatorName: 'نام تنظیم کننده',
            extraFlightCurrentDayTitle: 'ثبت پرواز فوق‌العاده/برقراری در روز جاری',
            extraFlightCurrentDay: 'ثبت پرواز فوق‌العاده/برقراری',
            fromDate: 'تغییر ساعت پرواز از تاریخ ',
            toDate: ' تا تاریخ ',
            toTime: ' به ساعت ',
            changes: 'تغییرات',
            timeChanges: 'تغییرات زمانی',
            reviewOffer: 'بررسی پیشنهاد',
            submitOffer: 'ثبت پیشنهاد',
            reviewRequest: 'بررسی درخواست',
            submitRequest: 'ثبت درخواست',
            offerStatus: 'پیشنهاد',
            reviewStatus: 'در حال بررسی',
            notConfirmed: 'عدم تایید',
            adminConfirmed: 'تایید ادمین',
            superAdminConfirmed: 'تایید سوپرادمین',
            supervisorConfirmed: 'تایید سوپروایزر',
            success: 'موفق',
            airlineCancelledStatus: 'لغو درخواست توسط هواپیمایی',
            airlineCompany: 'شرکت هواپیمایی',
            cancelRequest: 'لغو درخواست',
            letterContent: 'اطلاعات نامه',
            letterNumber: 'شماره نامه',
            enterLetterNumber: 'شماره نامه را وارد کنید',
            letterSubject: 'موضوع نامه',
            enterLetterSubject: 'موضوع نامه را وارد کنید',
            letterReplyTo: 'بازگشت به',
            letterReplyToRequests: 'درخواست‌های',
            request: 'درخواست',
            letterDate: 'مورخ',
            counterparts: 'رونوشت',
            flights: 'پروازها',
            operationDate: 'تاریخ اجرا',
            exitSource: 'خروج از تهران',
            enterSource: 'ورود به تهران',
            incomingTerminal: 'ترمینال ورودی',
            outgoingTerminal: 'ترمینال خروجی',
            signFile: 'فایل امضا',
            FlightRequestLetters: 'نامه‌ها',
            selectAll: 'انتخاب همه',
            asalouye: 'عسلویه',
            persianGulf: 'خليج فارس',
            flightRequestRemoval: 'حذف درخواست',
            file: 'فایل',
            singleFlight: 'یک پرواز',
            expirationDate: 'تاریخ انقضا',
            rplArchive: 'برنامه فصلی',
            season: 'فصل',
            path: 'مسیر',
            exitFlightNumber: 'شماره پرواز خروجی',
            enterFlightNumber: 'شماره پرواز ورودی',
            email: 'ایمیل',
            rplConstraints: 'محدودیت فصلی',
            rplDateTimeConstraints: 'محدودیت زمانی برنامه فصلی'
        },
        messages: {
            offlineAgentAfterContactEnd: 'پس از پایان مکالمه وضعیت تغییر خواهد کرد.',
            cannotChangeStatus: 'اجازه تغییر وضعیت وجود ندارد.',
            contactNotExist: 'تماسی وجود ندارد.',
            noPhoneNumber: 'شماره تلفن وارد نشده است.',
            callError: 'خطایی در برقراری تماس رخ داده است.',
            agentNotExist: 'کاربر وجود ندارد.',
            cannotRestInThisState: 'اجازه درخواست استراحت در این وضعیت وجود ندارد.',
            operatorCallerNoteFail: 'خطایی در ثبت مزاحم رخ داده است.',
            operatorCallerNoteSuccess: 'ثبت مزاحم با موفقیت انجام شد.',
            agentNotOnline: 'کاربر آنلاین نمی باشد.',
            transferSuccess: 'تماس با موفقیت منتقل شد.',
            transferFail: 'خطایی در انتقال تماس رخ داده است.',
            securityLicenseFail: 'شما مجوز استفاده از برنامه را ندارید',
            invalidShift: 'اجازه ورود در این شیفت برای شما وجود ندارد',
            passwordMustChange: 'به دلایل امنیتی شما باید کلمه عبور خود را تغییر دهید',
            successLogin: 'ورود با موفقیت انجام شد',
            userAlreadyInSystem: 'کاربر قبلا وارد شده است',
            emailNotExist: 'ایمیل وجود ندارد',
            syncDone: 'همگام سازی داخلی ها با موقبت انجام شد.',
            syncExtWithUi: 'همگام سازی داخلی ها',
            uploadLogo: 'لطفا لوگو مورد نظر را آپلود کنید',
            uploadVoiceFile: 'لطفا فایل صوتی مورد نظر را آپلود کنید',
            uploadedSuccessfully: 'با موفقیت بارگزاری شد',
            flightRequestCreated: 'درخواست با موفقیت ثبت شد',
            reviewFlightRequest: 'بررسی با موفقیت انجام شد',
            emptyFields: 'فیلدهای ضروری نمی توانند خالی باشند',
            monitoringNumberConfirmed: 'فرم درخواست را تکمیل فرمایید',
            firstConfirmMonitoringNotif: 'ابتدا باید شماره نظارت تایید شود',
            correctTheseErrors: 'لطفا خطاهای زیر را اصلاح کنید',
            belowChangesWillBeAffected: 'تغییرات زیر اعمال خواهد شد',
            chooseWeekDays: 'لطفا روزهای هفته را انتخاب کنید',
            rplDatesCanNotBeTheSame: 'تاریخ شروع و پایان در برنامه فصلی نمی‌تواند یکسان باشد',
            sureToConfirm: 'آیا از تایید این درخواست مطمئن هستید؟',
            sureToCancelFlights: 'آیا از ابطال پرواز(ها) اطمینان دارید؟',
            sureToReEstablishFlights: 'آیا از برقراری مجدد پرواز‌(ها) اطمینان دارید؟',
            sureToTimeChangeFlights: 'آیا از تغییر زمان پرواز(ها) اطمینان دارید؟',
            sureToOffer: 'آیا از پیشنهاد جدید مطمئن هستید؟',
            sureToReject: 'آیا از عدم تایید این درخواست مطمئن هستید؟',
            sureToSave: 'آیا از ذخیره این درخواست مطمئن هستید؟',
            approvedRequestSuccess: 'درخواست با موفقیت تایید شد',
            savedRequestSuccess: 'درخواست با موفقیت ذخیره شد',
            rejectRequestSuccess: 'عدم تایید درخواست انجام شد',
            offerRequestSuccess: 'پیشنهاد شما برای این درخواست با موفقیت ثبت شد',
            writeYourDescription: 'توضیحات خود را اینجا بنویسید',
            successfulOperation: 'عملیات با موفقیت انجام شد',
            failedOperation: 'عملیات با موفقیت انجام نشد',
            todayRequestNotAllowed: 'ثبت درخواست برای تاریخ امروز امکان پذیر نیست',
            beforeDateRequestNotAllowed: 'ثبت درخواست برای تاریخ گذشته امکان پذیر نیست',
            beforeRplStartDateNotAllowed: 'ثبت درخواست فصلی قبل از تاریخ شروع برنامه فصلی امکان پذیر نیست',
            afterRplEndDateNotAllowed: 'ثبت درخواست فصلی بعد از تاریخ پایان برنامه فصلی امکان پذیر نیست',
            twoWayDifferentFlightNumber: 'شماره پروازهای رفت و برگشت باید متفاوت باشند.',
            notInAllowedFlightNumberRange: 'شماره پرواز در بازه مجاز نیست.',
            changesApplied: 'تغییرات اعمال شد',
            correctErrors: 'لطفا خطاها را اصلاح کنید',
            deleteTimeRestrain: 'آیا از حذف این محدودیت اطمینان دارید؟',
            deleteCityRestrain: 'آیا از حذف این محدودیت شهری اطمینان دارید؟',
            deleteNightStayRestrain: 'آیا از حذف این ظرفیت شب خوابی اطمینان دارید؟',
            updateAirline: 'هواپیمایی بروزرسانی شود؟',
            addTimeRestrain: 'محدودیت اضافه شود؟',
            addCityRestrain: 'محدودیت شهری اضافه شود؟',
            addNightStayRestrain: 'ظرفیت شب خوابی اضافه شود؟',
            checkTimeChanges: 'لطفا تغییرات را بررسی کنید',
            confirmFlightRemoval: 'آیا از حذف این پرواز مطمئن هستید؟',
            emptyFlightPath: 'مسیر پرواز را انتخاب کنید',
            emptyFlightDirection: 'جهت پرواز را انتخاب کنید',
            emptySourceCity: 'مبدا را انتخاب کنید',
            emptyDestinationCity: 'مقصد را انتخاب کنید',
            emptyAirplaneType: 'نوع هواپیما را وارد کنید',
            emptyFlightNumber: 'شماره پرواز را وارد کنید',
            emptyMonitoringNumber: 'شماره نظارت را وارد کنید',
            emptyRegister: 'رجیستری را وارد کنید',
            emptyStaying: 'نوع شب خوابی را انتخاب کنید',
            sureToReviewOffer: 'پیشنهاد بررسی شود؟',
            sureToReviewRequest: 'درخواست جدید بررسی شود؟',
            sureToSubmitRequest: 'آیا از ثبت درخواست مطمئن هستید؟',
            noFlightFound: 'پروازی یافت نشد',
            cancelRequest: 'آیا از لغو درخواست مطمئن هستید؟',
            successFlightInfo: 'اطلاعات پرواز با موفقیت دریافت شد',
            failedFlightInfo: 'اطلاعات پرواز دریافت نشد',
            duplicateFlightNumberDays: 'شماره پرواز تکراری در روز‌(های)',
            duplicateFlightNumberFlights: 'با پرواز‌(های) شماره',
            successfullReportLetterCreation: 'نامه با موفقیت ایجاد شد',
            internalServerError: 'خطایی رخ داده است',
            minuteCapacity: 'ظرفیت در ساعت %{flightTime} تکمیل است.',
            notRightTime: 'مدت زمان پرواز درست تعیین نشده است: %{duration} دقیقه ',
            sureToRemoveFlightRequest: 'آیا از حذف این درخواست‌(ها) مطمئن هستید؟',
            flightInformation: 'مشخصات پرواز شماره %number',
            fidsConfirmed: 'اطلاعات خودکار وارد شده‌است',
            fidsNotConfirmed: 'اطلاعات دستی وارد شده‌است',
            resetUserMfa: 'ریست کردن ورود دو مرحله‌ای',
            notActiveRplSeason: 'در حال حاضر امکان ثبت این برنامه فصلی وجود ندارد',
            notAllowedByDateTimeConstraints: 'ثبت درخواست فقط در بازه زمانی مجاز',
            errorMessageExitFlight: 'تداخل با ساعت اذان. اقامه نماز در مقصد یا مبدا امکان پذیر نیست',
            errorMessageBlockTime: 'تداخل با ساعت اذان. اقامه نماز در مقصد یا مبدا امکان پذیر نیست',
            minuteCapacity: 'ظرفیت در ساعت 00:00 تکمیل است',
            samePathCapacity: 'تکمیل ظرفیت پروازهای هم مسیری',
            sameRouteCapacity: 'تکمیل ظرفیت پروازهای هم روتی',
            rplOnlyTimeRange: 'این نوع پرواز در این بازه ساعتی مجاز نیست',
            notInAllowedFlightNumberRange: 'شماره پرواز در بازه مجاز نیست',
            wrongDate: 'تاریخ درخواستی اشتباه است',
            airlinesNightStayShare: 'ظرفیت شب‌خوابی در این روز تکمیل است',
            airlineCityShare: 'سهمیه ایرلاین برای شهر مقصد تمام شده‌است',
            airlineHourlyShare: 'سهمیه پرواز ایرلاین در این بازه یک ساعته تمام شده‌است',
            hourCapacity: 'ظرفیت در این بازه زمانی تکمیل است',
            duplicateFlightNumber: 'شماره پرواز در این بازه برای این روز(ها) قبلا ثبت شده ‌است',
            cityNotFound: 'شهر مورد نظر یافت نشد',
            goingFlightTimeOverlap: 'تداخل زمانی با پرواز برگشت بعد از تغییر ساعت به دلیل تداخل اذان صبح',
            comingFlightTimeOverlap: 'تداخل زمانی با پرواز رفت بعد از تغییر ساعت به دلیل تداخل اذان صبح',
            goingFlightTimeOverlap_timechange: 'تداخل زمانی با پرواز برگشت',
            comingFlightTimeOverlap_timechange: 'تداخل زمانی با پرواز رفت',
        },
    },
    pos: {
        language: 'زبان',
        configuration: 'تنظیمات',
        search: 'جستجو',
        logout: 'خروج',
        completeLogout: 'خروج کامل',
        font: 'فونت',
        direction: 'جهت',
        home: {
            title: 'تقویم',
        },
        theme: 'تم',
    },
    resources: {
        posts: {
            name: 'پیام ها',
        },
        login: {
            transferToAuthProvider: 'ورود',
        },
        configuration: {
            name: 'تنظیمات',
        },
        dashboards: {
            name: 'داشبوردها',
            dName: 'نام',
            url: 'مسیر',
            description: 'توضیحات',
            removeDashboardApprove: 'آیا از حذف داشبورد اطمینان دارید؟',
        },
        security: {
            name: 'امنیت',
        },
        roles: {
            name: 'نقش ها',
            permission: {
                name: 'مجوز ها',
            },
            childrens: {
                name: 'نقش های فرزند',
            },
            resources: {
                name: 'منابع',
            },
        },
        targets: {
            name: 'هدف ها',
        },
        operations: {
            name: 'عملیات',
        },
        settings: {
            name: 'تنظیمات',
        },
        users: {
            name: 'کاربران',
        },
        phonebook: {
            addToPhoneBook: 'افزودن به دفترچه تلفن',
        },
        flightRequests: {
            name: 'درخواست ها',
        },
        report: {
            name: 'گزارش‌گیری',
        },
        request_report: {
            name: 'نامه‌ها',
        },
        rpls_list: {
            name: 'برنامه فصلی'
        }
    },
    components: {},
};
